import { useState } from "react";
import { Box, Button } from "@mui/material";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "../../components/common/TabPanel";
import {
  RequestCompany,
  ActiveCompany,
  InactiveCompany,
} from "../../components/company";
import { useNavigate } from "react-router-dom";

const CompanyList = () => {
  const navigate = useNavigate();

  const [tab, setTab] = useState(0);
  const [selection, setSelection] = useState([]);

  const handleChange = (event, newTab) => {
    setTab(newTab);
  };

  return (
    <Box
      sx={{
        height: "90%",
        width: "100%",
        px: { xs: "1rem", lg: "2rem" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Tabs
          value={tab}
          onChange={handleChange}
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            minHeight: "24px",
            "& .MuiTab-root": { minHeight: "24px", padding: "4px" },
            pt: 2,
          }}
        >
          <Tab label="Request" />
          <Tab label="Active" />
          <Tab label="Inactive" />
        </Tabs>
        <Box>
          <Button
            variant="contained"
            size="small"
            sx={{
              display: selection.length === 1 ? "block" : "none",
            }}
            onClick={() => navigate("details/" + selection[0])}
          >
            Details
          </Button>
        </Box>
      </Box>
      <TabPanel value={tab} index={0}>
        <RequestCompany handleOnSelecting={setSelection} />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <ActiveCompany handleOnSelecting={setSelection} />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <InactiveCompany handleOnSelecting={setSelection} />
      </TabPanel>
    </Box>
  );
};

export default CompanyList;
